import { iTimer, iTimerEvents } from "./types";

const _e = () => {
    // Placeholder function
};
const _defaultEvents = () => ({
    onStart: _e,
    onTick: _e,
    onStop: _e,
    onReset: _e
});

/**
 *  Timer Class
 */
class Timer implements iTimer {
    from = 0;
    to = 0;
    tick = 0;
    _ms = 100;
    _events: iTimerEvents;
    _iid?: NodeJS.Timeout;

    get elapsed() {
        return (this.isRunning() ? Date.now() : this.to) - this.from;
    }

    constructor(events: Partial<iTimerEvents> = {}) {
        this._events = {
            ..._defaultEvents(),
            ...events
        };
    }

    _tick() {
        this.tick += 1;
        this._events.onTick(this);
    }

    start() {
        if (!this._iid) {
            this.from = Date.now() - this.elapsed;
            this.to = 0;
            this._iid = setInterval(this._tick.bind(this), this._ms);
            this._events.onStart(this);
        }
        return this._iid;
    }

    stop() {
        if (this._iid) {
            clearInterval(this._iid);
            this.to = Date.now();
            this._iid = undefined;
            this._events.onStop(this);
        }
    }

    reset() {
        this.stop();
        this.from = 0;
        this.to = 0;
        this.tick = 0;
        this._events.onReset(this);
    }

    isRunning() {
        return !!this._iid;
    }
}

export default Timer;
